import React from 'react';
import {LabelDTO} from '../../models/dto/LabelDTO';
import {
    CheckboxContainer,
    ContentWrapper,
    DialogWrapper,
    Label,
    LabelFigure,
    LabelImage,
    LabelItem,
    LabelRatioWrapper
} from './LabelPicker.style';
import {t} from 'i18next';
import {generateIdentifier} from '../../utils/IdentityUtils';

export interface LabelsSelectionProps {
    readonly dataSource: LabelDTO[];
    readonly userLabels: string[];
    onChange: (userLabels: string[]) => void;
}

/**
 * @name LabelPicker
 * @description
 * Component to make a selection of labels that user can view on file tile/grid
 */
export const LabelPicker: React.VFC<LabelsSelectionProps> = (props) => {
    const saveLabel = (value: string) => {
        let userLabel = props.userLabels.slice();
        let keyIndex = userLabel.indexOf(value);
        if (keyIndex === -1) {
            userLabel.push(value);
        } else {
            userLabel.splice(keyIndex, 1);
        }

        props.onChange(userLabel);
    };

    const isSelected = (value: string): boolean => {
        if (props.userLabels != [] || props.userLabels.length >= 0) {
            return props.userLabels.includes(value);
        }

        return false;
    };

    const removeElement = (): void => {
        if (props.userLabels.length > 3) {
            let userLabel = props.userLabels.slice();
            userLabel.splice(userLabel.length - 1, 1);
            props.onChange(userLabel);
        }
    };

    const handleInput = (value: string) => {
        saveLabel(value);
    };

    return (
        <ContentWrapper id={generateIdentifier()}>
            {(props.dataSource.length > 0) ?
                <Label id={generateIdentifier()} htmlFor={'max-labels-reached'}>{t('MAXIMUM_NO_OF_LABELS')}</Label> :
                <Label id={generateIdentifier()} htmlFor={'no-labels-available'}>{t('LABELS_NOT_AVAILABLE')}</Label>
            }
            {props.dataSource.map(showLabel => {
                return (
                    <div id={generateIdentifier()}
                         key={showLabel.labelKey}
                         className='a-selectable-tile a-selectable-tile--checkbox -large'>
                        <input id={showLabel.labelKey}
                               type='checkbox'
                               name='Selectable Tile Checkbox'
                               checked={isSelected(showLabel.labelKey)}
                               onClick={() => handleInput(showLabel.labelKey)}/>
                        <LabelItem id={generateIdentifier()} htmlFor={showLabel.labelKey}>
                            <CheckboxContainer id={generateIdentifier()}
                                               className='checkbox-container'></CheckboxContainer>
                            <LabelFigure id={generateIdentifier()}>
                                <LabelRatioWrapper id={generateIdentifier()}>
                                    <LabelImage id={generateIdentifier()}
                                                src={showLabel.label}
                                                alt='Labels'/>
                                    <div id={generateIdentifier()} className='a-text'>
                                        <p id={generateIdentifier()}
                                           className='-size-s highlight a-text__headline'>{showLabel.labelType}</p>
                                    </div>
                                </LabelRatioWrapper>
                            </LabelFigure>
                        </LabelItem>
                    </div>
                )
            })}
            {(props.userLabels.length > 3) &&
                <DialogWrapper id={generateIdentifier()}
                               key={'key'}
                               modal
                               open
                               title={t('INFO')}
                               headline={t('MAXIMUM_NO_OF_LABELS')}
                               onClose={removeElement}>
                </DialogWrapper>
            }
        </ContentWrapper>
    );
};
